import { useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Dropdown from "react-bootstrap/Dropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
// -
import AuthContext from "context/AuthContext";
import WaypointIcons from "site-apps/distribution/waypoints/WaypointIcons";
import axiApi from "ApiCaller";
import { updateListById } from "core/utils/arrays";
import FormButton from "components/buttons/FormButton";
import { subscribeEvent, unsubscribeEvent } from "core/eventsConnector";
import MapManagerModal from "components/maps/MapManagerModal";
import MapPointManager from "components/maps/MapPointManager";

const FormWaypoints = ({ showForm, setShowForm, item, items, setItemsShown }) => {
    const { panel } = useContext(AuthContext);
    const { t: _Tf } = useTranslation("forms");
    const [_Tc] = useTranslation("choices");
    const { t: tR } = useTranslation("routes");
    const [formData, setFormData] = useState({ ...item });
    const [type, setType] = useState({ title: "Seleccionar", value: "" });
    const [position, setPosition] = useState([0, 0]);
    const [isLoading, setIsLoading] = useState(false);
    const [showMapModal, setShowMapModal] = useState(false);
    const [showMap, setShowMap] = useState(false);

    useEffect(() => {
        setFormData({ ...item });
        item.lat && item.lng
            ? setPosition([item.lat, item.lng])
            : setPosition(panel.coords);

        item.type
            ? setType({ title: _Tc("waypoints_types." + item.type), value: item.type })
            : setType({ title: "Seleccionar", value: "" });
    }, [item]);

    useEffect(() => {
        const handlePositionSelected = (e) => {
            const { lat, lng } = e.detail;
            setFormData((prev) => ({
                ...prev,
                lat: lat.toFixed(6),
                lng: lng.toFixed(6),
            }));
        };

        subscribeEvent("mapmodal:position:selected", handlePositionSelected);

        return () => {
            unsubscribeEvent("mapmodal:position:selected", handlePositionSelected);
        };
    }, []);

    const handleMapClick = (latlng) => {
        setPosition([latlng.lat.toFixed(6), latlng.lng.toFixed(6)]);
        formData.lat = latlng.lat.toFixed(6);
        formData.lng = latlng.lng.toFixed(6);
        setFormData(formData);
    };

    const handleModalMap = () => {
        setShowMapModal(true);
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        let form = { ...formData };
        form[name] = value;
        setFormData(form);
        if (name === "lat" || name === "lng") {
            setPosition([form.lat, form.lng]);
        }
    };
    const handleType = (e) => {
        let _type = { ...type };
        _type.title = _Tc("waypoints_types." + e);
        _type.value = e;
        setType(_type);
    };

    const handleClose = () => {
        setShowForm(false);
    };

    const clickCancel = () => {
        setShowForm(false);
    };

    const onSummit = (e) => {
        setIsLoading(true);
        e.preventDefault();
        let form = new FormData(e.target);

        axiApi.post(`/api/distribution/waypoint/`, form).then((resp) => {
            if (resp.status === 200) {
                if (formData.id) {
                    items.current.all = updateListById(
                        items.current.all,
                        resp.data.item
                    );
                    let index = items.current.showed.findIndex(
                        (item) => item.id === formData.id
                    );
                    items.current.showed[index] = resp.data.item;
                } else {
                    items.current.showed.push(resp.data.item);
                }
                setItemsShown([...items.current.showed]);
                handleClose();
            }
            setIsLoading(false);
        });
    };

    return (
        <>
            <Offcanvas
                show={showForm}
                onHide={handleClose}
                placement="end"
                backdrop="static"
                style={{ width: "40%", fontSize: "15px" }}>
                <Offcanvas.Header className="preview-canvas">
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="map-location-dot" />
                    </div>
                    <div className="preview-title">
                        <Offcanvas.Title>{tR("labels.waypoints")}</Offcanvas.Title>
                    </div>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <form className="ms-auto" onSubmit={onSummit}>
                        <input type="hidden" name="id" defaultValue={formData.id} />
                        <div className="row g-3 align-items-center ">
                            <div className="col-3 text-end">
                                <label htmlFor="name" className="col-form-label">
                                    {_Tf("common.name")}
                                </label>
                            </div>
                            <div className="col-9">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    name="name"
                                    defaultValue={item.name}
                                    required
                                />
                            </div>
                        </div>
                        <div className="row g-3 align-items-center mt-3">
                            <div className="col-3 text-end">
                                <label
                                    htmlFor="full_address"
                                    className="col-form-label">
                                    {_Tf("common.full-address")}
                                </label>
                            </div>
                            <div className="col-9">
                                <textarea
                                    rows="3"
                                    className="form-control"
                                    id="full_address"
                                    name="full_address"
                                    defaultValue={item.full_address}
                                />
                            </div>
                        </div>
                        <div className="row g-3 align-items-center mt-2">
                            <div className="col-3 text-end">
                                <label htmlFor="type" className="col-form-label">
                                    {_Tf("common.type")}
                                </label>
                            </div>
                            <div className="col-9">
                                <input
                                    type="hidden"
                                    className="form-control mb-2"
                                    id="type"
                                    name="type"
                                    value={type.value}
                                />
                                <Dropdown as={ButtonGroup} onSelect={handleType}>
                                    <Button
                                        variant="outline-secondary"
                                        style={{ minWidth: "120px" }}
                                        disabled>
                                        {type.title}
                                    </Button>
                                    <Dropdown.Toggle
                                        split
                                        variant="outline-secondary"
                                        id="dropdown-split-basic"
                                    />
                                    <Dropdown.Menu>
                                        <Dropdown.Item eventKey="p">
                                            {_Tf("waypoints.parking")}
                                        </Dropdown.Item>
                                        <Dropdown.Item eventKey="g">
                                            {_Tf("waypoints.gas_station")}
                                        </Dropdown.Item>
                                        <Dropdown.Item eventKey="t">
                                            {_Tf("waypoints.workshop")}
                                        </Dropdown.Item>
                                        <Dropdown.Item eventKey="r">
                                            {_Tf("waypoints.landfill")}
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                                {type.value ? (
                                    <div className="d-inline-block ms-3 border p-2">
                                        <WaypointIcons type={type.value} />
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </div>
                        <div className="row g-3 align-items-center mt-3">
                            <div className="col-3 text-end">
                                <label htmlFor="time" className="col-form-label">
                                    {_Tf("waypoints.time-stop")}
                                </label>
                            </div>
                            <div className="col-9">
                                <input
                                    type="number"
                                    className="form-control mb-2 text-end"
                                    id="time"
                                    name="time"
                                    value={formData.time}
                                    onChange={handleChange}
                                    required
                                    style={{ width: "90px" }}
                                />
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-1"></div>
                            <div className="col-10 card pb-3">
                                <div className="row">
                                    <div className="col-1"></div>
                                    <div className="mt-2 col-4">
                                        <label htmlFor="lat" className="form-label">
                                            {_Tf("common.latitude")}
                                        </label>
                                        <input
                                            type="number"
                                            max="90"
                                            min="-90"
                                            className="form-control"
                                            id="lat"
                                            name="lat"
                                            step="any"
                                            value={formData.lat}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mt-2 col-4">
                                        <label htmlFor="lng" className="form-label">
                                            {_Tf("common.longitude")}
                                        </label>
                                        <input
                                            type="number"
                                            max="90"
                                            min="-90"
                                            step="any"
                                            className="form-control"
                                            id="lng"
                                            name="lng"
                                            value={formData.lng}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-1"></div>
                                    <div className="mt-4 pt-3 col-2">
                                        <Button
                                            title="Editar ubicación"
                                            variant="btn btn-outline-primary"
                                            type="button"
                                            onClick={handleModalMap}>
                                            <FontAwesomeIcon icon="fa-map-location-dot" />
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row g-3 align-items-center mt-3">
                            <MapPointManager
                                center={[formData.lat, formData.lng]}
                                onMapClick={handleMapClick}
                            />
                        </div>

                        <div className="mt-5 text-end mb-5">
                            <div className="mt-5 d-flex justify-content-end align-right">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={clickCancel}>
                                    Cancelar
                                </button>
                                {/* <button type="submit" className="btn btn-primary ms-3">Guardar</button> */}
                                <FormButton
                                    label="Guardar"
                                    type="submit"
                                    className="btn btn-primary ms-3"
                                    isProcessing={isLoading}>
                                    Guardar
                                </FormButton>
                            </div>
                        </div>
                    </form>
                </Offcanvas.Body>
                <MapManagerModal
                    show={showMapModal}
                    setShow={setShowMapModal}
                    title={"Waypoints"}
                    initialLat={formData.lat}
                    initialLng={formData.lng}
                />
            </Offcanvas>
        </>
    );
};

export default FormWaypoints;
